// extracted by mini-css-extract-plugin
export default {"container":"sb-spinner_container_BtAIo"};